import signalr from 'BASE/common/signalrAdapter';
import { actionTypes } from 'BASE/store/types';
import chat from 'TS/views/Chat/Chat';
import BetAwardNotifyComponent from 'BASE/components/notification/betAwardNotify.component';
import websiteInfoUtil from 'BASE/common/util/util.websiteInfo';
import userInfo_component from 'BASE/components/userInfo.component';
import afk from 'BASE/components/downLoad/AFK';
import top_header_component from 'TS/views/TopHeader';
import announcement_component from 'TS/views/Announcement';
import { browser } from 'BASE/common/util/util.browser';
import IEAlertComponent from 'TS/views/IEAlert.vue';

export default {
    data: function () {
        return {
            minHeight: 600,
            indexbg:"indexbg",
        };
    },
    mixins: [websiteInfoUtil, userInfo_component, afk],
    components: {
        chat,
        BetAwardNotifyComponent,
        top_header_component,
        announcement_component,
        IEAlertComponent,
    },
    computed: {
        isLogin() {
            return this.$store.state.userinfo.isLogin;
        }
    },
    methods: {
        resizeContent() {
            let _header = this.isLogin && $("header").is(":visible") ? $("header").outerHeight() : 0;
            let _footer = this.isLogin && $("footer").is(":visible") ? $("footer").outerHeight() : 0;
            if(typeof _header === 'undefined')
                _header = 0;
            
            if(typeof _footer === 'undefined')
                _footer = 0;

            this.minHeight = $(window).height() - _header - _footer;
        },
        async refreshAmount() {
            await this.$store.dispatch(actionTypes.USER_INFO_WALLET_AMOUNT);
        },
        showAnnouncement(id, index) {
            if(this.$refs && this.$refs.Announcement)
            {
                this.$refs.Announcement.showAnnouncement(id, index);
            }
        }
    },
    created() {
        signalr.init();
    },
    updated(){
        this.resizeContent();
    },
    mounted() {
        if (browser.isIE)
            this.$refs.ieAlert.showDialog();

        let _this = this;
        //先執行一次變更內容區最小高度，綁定視窗變更事件
        this.resizeContent();
        window.addEventListener('resize',() => _this.resizeContent());
    },
    watch: {
        "$route.path": function (val) {
            if(val == "/"){
                this.indexbg = "indexbg";
            }
            else {
                this.indexbg = "";
            }
        }
    },
};